import mainnetAddresses from '@arcxgame/contracts/dist/deployments/mainnet/deployed.json'
import playnetAddreses from '@arcxgame/contracts/dist/deployments/playnet/deployed.json'
import rinkebyAddresses from '@arcxgame/contracts/dist/deployments/rinkeby/deployed.json'
import { Network } from './Network'

export function getAddressesForNetwork(network: Network, isPlaynet = false) {
  if (isPlaynet) {
    return playnetAddreses
  }

  switch (network) {
    case Network.Mainnet:
      return mainnetAddresses
    case Network.Rinkeby:
      return rinkebyAddresses
    default:
      return []
  }
}
